import { BreakpointsOptions } from '@mui/material';

export const Breakpoints: BreakpointsOptions = {
  values: {
    xl: 1440,
    lg: 1240,
    md: 905,
    sm: 600,
    xs: 0,
  },
};
